import ConfigLOCAL from './local.json';
import ConfigDEV from './dev.json';
import ConfigTI from './ti.json';
import ConfigTEST from './test.json';
import ConfigPP from './pp.json';
import ConfigPROD from './prod.json';
import { URLS, ENV } from '../utils/constants';
import { ConfigType } from './index';

export const getConfigType = (): ConfigType => {
  const host = window.location.host || '';
  const pathname = window.location.pathname || '';
  const nodeEnv = process.env.NODE_ENV;

  // Local development: localhost uses relative URLs via webpack proxy
  if (host.startsWith('localhost') || host.startsWith('127.0.0.1')) {
    return ConfigLOCAL;
  }

  // In cloud deployment, detect environment from URL path
  // Note: PP and PROD both use /bao/ path, differentiated by hostname
  if (pathname.startsWith('/bao-ti')) {
    return ConfigTI;
  } else if (pathname.startsWith('/bao-tu')) {
    return ConfigDEV;
  } else if (pathname.startsWith('/bao-ta')) {
    return ConfigTEST;
  } else if (
    pathname.startsWith('/bao/') &&
    (host.includes('iiroc-pp.investments.apis.bnc.ca') || host.includes('pprod.'))
  ) {
    return ConfigPP;
  } else if (pathname.startsWith('/bao/') && host.includes('iiroc.investments')) {
    return ConfigPROD;
  }

  // Fallback to hostname-based detection for on-premise environments
  if (host === URLS.DEV.EN || host === URLS.DEV.FR || nodeEnv === ENV.DEV) {
    return ConfigDEV;
  } else if (host === URLS.TI.EN || host === URLS.TI.FR) {
    return ConfigTI;
  } else if (host === URLS.TEST.EN || host === URLS.TEST.FR || nodeEnv === ENV.TEST) {
    return ConfigTEST;
  } else if (host.includes('iiroc-pp.investments.apis.bnc.ca') || host.includes('pprod.')) {
    return ConfigPP;
  } else {
    return ConfigPROD;
  }
};
